import {Box, Typography} from '@mui/material';
import {RunningWithErrorsTwoTone} from '@mui/icons-material';
import React from 'react';

const SpigotDraft = ( {draftObj: spigot} ) => {
    const probability = spigot?.json_data?.spigot_data?.probability_of_journey;
    const probabilityPercent = probability ? Math.round(probability * 100) : null;
    
    return (
        <Box className='flow-sidebar__body-hihlighter' display='flex' style={{padding: '5px 25px', marginTop: 30}}>
            <Box sx={{width: '100%'}} display='flex' flexDirection='column'>
                <Box display='flex' flexGrow={1} alignItems='center' mb={2}>
                    <RunningWithErrorsTwoTone style={{marginRight: 10}}/>
                    <Typography component='div' variant='subtitle1'>
                        Draft: <span style={{fontWeight: 400}}>
                            {probabilityPercent !== null ? `${probabilityPercent}% will continue, ${100 - probabilityPercent}% will exit` : 'Not set'}
                        </span>
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default SpigotDraft; 